wbApp.controller('EmployeeAvailabilitySchedulesCtrl', ['$scope', '$modal', 'employeeAvailabilitySchedulesSvc', 'messageBoxSvc',
function ($scope, $modal, employeeAvailabilitySchedulesSvc, messageBoxSvc) {

    var isActive = false;    
    var loaded = false;
    var selectedWeek = moment().startOf('isoWeek');
    var selectedEmployee = null;

    $scope.model = [];
    var modelOrig = [];

    $scope.isBusy = false;
    $scope.isSaving = false;

    function reloadDataWithModificationAsk(saveEmployee, newEmployee, startOfWeek) {
        if (!$scope.detailIsUnchanged()) {
            messageBoxSvc.showMessageDlg({
                title: 'TXT_LBL_QUESTION',
                message: 'TXT_MODEL_MODFIFIED_SHOULD_SAVE',
                buttons: [{
                    text: 'TXT_BTN_NO',
                    callback: function () {
                        loadData(newEmployee, startOfWeek);
                    }
                }, {
                    text: 'TXT_BTN_SAVE',
                    callback: function () {
                        saveModel($scope.model, saveEmployee, function () {
                            loadData(newEmployee, startOfWeek);
                        });
                    }
                }]
            });
        }
        else {
            loadData(newEmployee, startOfWeek);
        }
    }

    function loadData(employee, date) {
        if (employee && date) {
            $scope.isBusy = true;
            employeeAvailabilitySchedulesSvc.loadWeek(employee.employeeID, date).then(
                function (data) {
                    $scope.isBusy = false;
                    selectedEmployee = employee;
                    selectedWeek = moment(date).startOf('isoWeek');
                    $scope.model.length = 0;
                    $scope.model.push.apply($scope.model, data);
                    modelOrig = angular.copy($scope.model);

                    loaded = true;
                }, function (error) {
                    $scope.isBusy = false;
                    selectedEmployee = null;
                    selectedWeek = moment(date).startOf('isoWeek');
                    $scope.model.length = 0;

                    modelOrig = [];
                    loaded = false;
                });
        }
    }

    $scope.$on('employeeSelectionChanged', function (e, newlySelectedEmployee) {
        if (newlySelectedEmployee) {
            if (isActive) {
                if (selectedEmployee != newlySelectedEmployee) {
                    reloadDataWithModificationAsk(selectedEmployee, newlySelectedEmployee, selectedWeek)
                }
            }
        }
        else {
            $scope.model.length = 0;
        }

        selectedEmployee = newlySelectedEmployee;
    });

    $scope.$on('activeTabChanged', function (e, data) {
        if (data.activeTab === 1) {
            if (!isActive) {
                isActive = true;
                if (!loaded && selectedEmployee) {
                    loadData(selectedEmployee, selectedWeek);
                }
            }
        } else {
            isActive = false;
        }
    });

    function saveModel(model, employee, callback) {
        if (!$scope.detailIsUnchanged() && !$scope.isBusy && !$scope.isSaving && !!selectedEmployee) {

            $scope.isSaving = true;

            employeeAvailabilitySchedulesSvc.saveWeek(employee.employeeID, selectedWeek, model).then(
                function (data) {

                    modelOrig = angular.copy($scope.model);
                    $scope.isSaving = false;
                    if (!!callback) {
                        callback();
                    }
                },
                function (error) {
                    $scope.isSaving = false;
                    messageBoxSvc.showMessageDlg({
                        title: 'TXT_ALERT_TITLE_ENTITY_SAVE_ERROR',
                        message: error.message,
                        buttons: [{
                            text: 'TXT_BTN_OK',
                            callback: function () {
                                if (!!callback) {
                                    callback();
                                }
                            }
                        }]
                    });

                }
            );
        }
    }

    $scope.calendarSettings = {
        onValueChanged: function (value) {
            var newStartOfWeek = moment(value.value).startOf('isoWeek');

            if (!newStartOfWeek.isSame(selectedWeek)) {
                reloadDataWithModificationAsk(selectedEmployee, selectedEmployee, newStartOfWeek);
            }
        }
    }

    $scope.detailIsUnchanged = function () {
        return angular.equals($scope.model, modelOrig);
    };

    $scope.onModelSave = function (model) {
        saveModel(model, selectedEmployee);
    }

    $scope.onModelCancel = function () {
        loadData(selectedEmployee, selectedWeek);
    }

    $scope.isSaveRangeEnabled = function () {
        return !$scope.isBusy && !$scope.isSaving && !!selectedEmployee && !!selectedWeek;
    }

    $scope.onModelRangeSave = function (model) {

        $scope.isSaving = true;
        dateRangeSelectionDlg.$promise.then(function () {
            dateRangeSelectionDlg.$scope.model = {
                from: moment().startOf('week').toDate(),
                to: moment().endOf('week').startOf('day').toDate(),
            };
            dateRangeSelectionDlg.$scope.onCanceled = function () {
                $scope.isSaving = false;
            },
            dateRangeSelectionDlg.$scope.onSaved = function (rangeModel) {
                employeeAvailabilitySchedulesSvc.saveWeekAsPaternForPeriod(
                   selectedEmployee.employeeID,
                   rangeModel.from,
                   rangeModel.to,
                   model).then(
                        function (data) {
                            modelOrig = angular.copy($scope.model);
                            $scope.isSaving = false;
                        },
                        function (error) {
                            $scope.isSaving = false;
                            messageBoxSvc.showMessageDlg({
                                title: 'TXT_ALERT_TITLE_ENTITY_SAVE_ERROR',
                                message: error.message,
                                buttons: [{
                                    text: 'TXT_BTN_OK'
                                }]
                            });                            
                        }
                    );
            }
                
            dateRangeSelectionDlg.show();
        });

    }

    var dateRangeSelectionDlg = $modal({
        templateUrl: 'users/dialogs/select-week-date-range.html',
        show: false,
        scope: $scope.$new()
    });
}]);
